<template>
    <div style="background: #fff;height:100%">
        <Headers :title="title"></Headers>
        <div class="card-wrap">
            <div class="photo-wrap">
                <img class="profile-photo" :src="require('@/assets/user/avatar.png')">
                <p class="personal-name">{{ userInfo.real_name }}</p>
            </div>
             <div class="item">
                <p class="title">{{ card.phone}}</p>
                <input class="position-value" v-model="phone" disabled style="color:#666" type="text" placeholder="请输入">
            </div>
            <div class="item">
                <p class="title">{{ card.company }}</p>
                <input class="position-value" v-model="company_name" type="text" placeholder="请输入">
            </div>
            <!-- <div class="item">
                <p class="title">{{ card.email}}</p>
                <input class="position-value" v-model="email" type="text" placeholder="请输入">
            </div> -->
            <div class="item">
                <p class="title position">{{ card.post}}</p>
                <input class="position-value" v-model="post" type="text" placeholder="请输入">
            </div>
            <div class="upload-item">
                <p class="title">{{ card.elecCard}}:</p>
                <div class="upload">
                    <img class="card-img" v-show="cardUrl" :src="cardUrl" alt="" />
                    <img class="icon" v-show="!cardUrl" :src="require('@/assets/upload.png')" alt="" />
                    <input type="file" accept="image/jpeg,image/jpg,image/png" @change="fileChange" ref="fileIpt" />
                </div>
            </div>
            <div class="btn-wrap">
                <p class="save-btn" @click="handleSubmit">{{ card.save}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import { mapState } from "vuex";
import api from "@/api";


export default {
    data() {
        return {
            cardUrl: "",
            post: "",
            company_name: "",
            phone: "",
            email: ""
        };
    },
    mounted() {
        this.getMyCard();
    },
    methods: {
        handleSubmit() {
            api.setMyCard({
                id: this.id,
                params: {
                    post: this.post,
                    company_name: this.company_name,
                    card_img_id: this.card_img_id,
                    phone: this.phone,
                    email: this.email
                }
            }).then((res) => {
                if (res.res === 1) {
                    this.$notify({type: 'success', message: this.$t('myCard').save_success });
                }
            });
        },
        getMyCard() {
            api.getMyCard().then((res) => {
                if (res.res === 1) {
                    this.id = res.card.id;
                    this.post = res.card.post;
                    this.company_name = res.card.company_name
                    this.email = res.card.email
                    this.phone = res.card.phone
                    this.cardUrl = res.card.card_image ? res.card.card_image.url : "";
                }
            });
        },
        fileChange(e) {
            var file = e.target.files[0]; //获取图片资源
            let isImgSize = file.size / 1024 / 1024 > 2
            console.log(file.size) 
            console.log(isImgSize)
            if (!file) return;
            var filename = file.name;
            // 只选择图片文件
            if (!/(png|jpg|jpeg)(\?.*)?$/.test(file.type)) {
                this.$notify({ type: 'danger', message: this.$t('myCard').img_format });
                this.$refs.fileIpt.value = "";
                return false;
            }
            if(isImgSize){
                return this.$notify({ type: 'danger', message: this.$t('myCard').img_size });
            }
            // 生成预览图片
            const reader = new FileReader();
            reader.onload = (evt) => {
                const target = evt.target || evt.srcElement;
                this.cardUrl = target.result;
            };
            reader.readAsDataURL(file);
            // 上传文件
            const FILE = new FormData();
            FILE.append("file", file);
            api.uploadFile(FILE).then((res) => {
                if (res.res === 1) {
                    this.card_img_id = res.id;
                    this.$notify({ type: 'success', message: this.$t('myCard').save_tip });
                }
            });
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return  this.language == 'zh' ?  '我的名片' : 'My business card'
        },
        ...mapState(["userInfo","language"]),
        card() {
            return this.$t("userCenter");
        }
    },
    components: {
        Headers
    }
}
</script>

<style lang="scss" scoped>
.card-wrap{
    height: auto;
    padding: 20px;
    box-sizing: border-box;
    margin-top: 15px;
    background-color: #fff;
    .photo-wrap{
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .profile-photo{
            width: 78px;
            height: 78px;
            margin-right: 15px;
            border: 1px solid #ccc;
            border-radius: 100%;
        }
        .personal-name{
            font-size: 20px;
            color: #333;
            font-weight: 500;
        }
            
    }
    .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 19px 21px 15px 13px;
        border-bottom: 1px solid #e1e1e1;
        font-size: 1.5rem;
        box-sizing: border-box;
        color: #999;
        font-size: 16px;
        .title{
            color: #333
            &position{
                position: relative
            }
            &::before{
                content: '*';
                position: absolute;
                width: 7px;
                height: 7px;
                left: -8px;
                top: 3px;
                color: #3B91C3;
            }
        }
        .company-name{
            width: 200px;
            text-align: right;
            line-height: 2rem;
            word-break: break-all ;
        }
        .position-value{
            color: #999;
            text-align: right;
            &::-webkit-input-placeholder{
                color: #999    
            }
        }             
    }
    .upload-item{
        display: flex;
        flex-direction: column;
        padding-top: 19px;
        .title {
            color: #09468c;
            font-weight: 500;
            margin-bottom: 15px;
            font-size: 16px;
        }
        .upload {
            width: 6.4rem;
            height: 5rem;
            border-radius: 13px;
            border: 2px dashed #e2e2e2;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            overflow: hidden;
            .icon {
                width: 22px;
                height: 22px;
            }
            .card-img {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                z-index: 1;
                object-fit: cover;
            }
            input {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                cursor: pointer;
                opacity: 0;
                z-index: 9;
            }
        }
    }   
    .btn-wrap{
        margin-top: 1rem;
        display: flex;
        justify-content: center;
        .save-btn{
            color: #fff;
            font-size: 18px;
            width: 238px;
            height: 49px;
            line-height: 49px;
            text-align: center;
            // background: linear-gradient(180deg, #52B4DD 0%, #246DA8 100%);
            background: #194b96;
            border-radius: 24px;
        }
    }
}
    
    
    
    
    
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobilePersonalCenter/myCard.vue